import { StyledProgressbar } from "../styled";

interface ITooltipProps {
  isMinorTablet: boolean;
  order: number;
  allQuestions: number;
}

export const Tooltip = ({
  isMinorTablet,
  order,
  allQuestions,
}: ITooltipProps) => {
  return (
    <StyledProgressbar
      className="w-fit flex items-center"
      style={{ ...(isMinorTablet ? { height: '32px' } : { height: '36px' }) }}
    >
      {order - 1} de {allQuestions} preguntas respondidas
    </StyledProgressbar>
  );
};
